<template>
  <div v-if="opqIf">
    <infobulle :descriptionPopup="descriptionPopup">
      <label :for="idInner" v-if="libelleLong"><div v-html="libelleLong" class="mb-1"></div></label>
      <file-input-base
        :width="width"
        :code="code"
        :file="file"
        :live="live"
        :optional="optional"
        @input="handleInput"
        ref="fileInput"
      ></file-input-base>
    </infobulle>
  </div>
</template>

<script>
import FileInputBase from "@/components/Form/FileInputBase.vue"
import ChampBase from "@/mixins/ChampBase"

// @group Champs
export default {
  mixins: [ChampBase],
  props: {
    width: { type: String, default: "420" },
    code: { type: String, required: true },
    file: { type: Object, default: undefined },
    live: { type: Object },
    optional: { type: Boolean, default: false },
    opqIf: { type: Boolean, default: true },
    id: { type: String }
  },
  components: {
    FileInputBase
  },
  methods: {
    handleInput(fileDto) {
      this.$emit("input", fileDto)
    }
  },
  watch: {
    opqIf(newValue) {
      if (!newValue) {
        this.$refs.fileInput.deleteFile()
      }
    }
  }
}
</script>

<style>
</style>